<div id="dvUnauthenticated" class="row mt-2 ml-2" *ngIf="status === '401'">
  <h2>&nbsp;&nbsp;{{ resources?.unauthenticatedMessage }}</h2>
  <br />
</div>

<div id="dvUnauthorized" class="row mt-2 ml-2" *ngIf="status !== '401'">
  <h2>&nbsp;&nbsp;{{ resources?.unauthorizedMessage }}</h2>
  <button type="button" class="btn btn-standard-ico" (click)="navigateBack()" id="btnGoBack">{{ resources?.goBackButton }}</button>
  <br />
</div>
